import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Grid, TextField, makeStyles, Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import axios from "axios";
import moment from "moment";
import { LoadingButton } from "@material-ui/lab";
import { CSVLink } from "react-csv";
import SubCard from "../../../ui-component/cards/SubCard";
import { getDecryptDataFromLocal } from "../../../utils/encrypt";

const bulkChildOrderHeader = [
  { label: "Name", key: "name" },
  { label: "Order Id", key: "numericOrderId" },
  { label: "Parent Bulk NumericOrderId", key: "parentBulkNumericOrderId" },
  { label: "Main Bulk NumericOrderId", key: "mainBulkNumericOrderId" },
  // { label: "PhoneNumber", key: "phoneNumber" },
  { label: "Total Payable Amount", key: "totalPayableAmount" },
  { label: "Payment Method", key: "paymentMethod" },
  { label: "Payment Id", key: "paymentId" },
  { label: "Razor Pay Order Id", key: "razorPayOrderId" },
  { label: "Is Auto Approvedt", key: "isAutoApproved" },
  { label: "Is Splited Order", key: "isSplitedOrder" },
  { label: "Created At", key: "createdAt" },
  { label: "Order Stage", key: "orderStage" },
  { label: "Status", key: "status" },
  { label: "Shipping Type", key: "shippingType" },
  { label: "Weight", key: "weight" },
  { label: "Box Count", key: "boxCount" },
  { label: "Pushed To ProductOrder", key: "pushedToProductOrder" },
  { label: "ewayBillNumber", key: "ewayBillNumber" },
  { label: "rocketBoxInvoiceUrl", key: "rocketBoxInvoiceUrl" },
  { label: "cnDiscountPercentage", key: "cnDiscountPercentage" },
  { label: "totalMargin", key: "totalMargin" },
  { label: "ucSalesOrderCreatedAt", key: "ucSalesOrderCreatedAt" },
  { label: "zohoInvoice", key: "zohoInvoice" },
  { label: "splitted", key: "splitted" },
  { label: "zohoInvoiceDate", key: "zohoInvoiceDate" },
  { label: "zohoInvoiceUrl", key: "zohoInvoiceUrl" },
  { label: "zohoInvoiceCreditNoteNumber", key: "zohoInvoiceCreditNoteNumber" },
  { label: "ucInvoiceIdsForBulkOrder", key: "ucInvoiceIdsForBulkOrder" },
  { label: "agentName", key: "agentName" },
  { label: "awbNumber", key: "awbNumber" },
  {label: "immediateSenior", key: "immediateSenior"},
  {label: "Manager", key: "managerName"},
  {label: "city", key: "city"},
  {label: "state", key: "state"},
  {label: "agentId", key: "agentId"},
  {label: "sellerId", key: "sellerId"},
  {label: "shippingCost", key: "shippingCost"},
  {label: "rtoDeliveryDate", key: "rtoDeliveryDate"},
  {label: "RTO Delivered Date", key: "rtoDeliveredDate"},
  {label: "Prepaid Collected Amount", key: "prepaidCollectedAmount"},
  { label: "Cancelled At", key: "cancelledAt" },
  { label: "Cancel Reason", key: "cancelReason" },
  { label: "Unique Seller Id", key: "uniqueSellerId" },
  { label: "Seller Created At", key: "sellerCreatedAt" },
  { label: "First Order Date", key: "firstOrderDate" },
  { label: "Status Text", key: "courierStatusText" },
  { label: "WA Lead Source", key: "waSource" },
  { label: "Lead Created Date", key: "leadCreatedDate" },
  { label: "Ad Name", key: "adName" },
  { label: "Adset Name", key: "adsetName" },
  { label: "Campaign Name", key: "campaignName" },
  { label: "First Out For Delivery Date", key: "firstOutForDeliveryDate" },
  { label: "Out For Delivery Count", key: "outForDeliveryCount" },
  { label: "At Delivery Center Date", key: "atDeliveryCenterDate" },
  { label: "Reached At Destination Date", key: "reachedAtDestinationAt" },
  { label: "Verified By", key: "verifiedByName" },
  { label: "FBL Prime Plan", key: "primeMembershipTier" },
  { label: "FBL Prime Amount", key: "primeMembershipAmount" },
  { label: "FBL Prime Status", key: "primeMembershipStatus" },
  { label: "FBL Prime Free Gift SKUs", key: "primeFreeGiftSkuNames" },
];

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));
function BulkDownloadOrderData() {
  const classes = useStyles();
  const currentRole = getDecryptDataFromLocal('setRole');
  const currentPhone = getDecryptDataFromLocal('phoneNumber');

  // Access guard: userType 1, 2, 3, 4, 17, 5 (agent), 13/14 (TL/FM), Manjay (bulkWaManager), or phone 9873804039.
  // Backend scopes the data per user (agent -> self, TL/FM -> own team, Ameen -> all retail, Manjay -> bulk team only).
  const allowedRoles = [1, 2, 3, 4, 17, 5, 13, 14];
  const allowedPhone = '9873804039';
  let isBulkWaManager = false;
  try { isBulkWaManager = localStorage.getItem('bulkWaManager') === 'true'; } catch (e) { /* ignore */ }
  if (!allowedRoles.includes(Number(currentRole)) && currentPhone != allowedPhone && !isBulkWaManager) {
    return <Redirect to="/dashboard/default" />;
  }
  const [date, setDate] = useState({
    startDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
    endDate: new Date().toISOString().slice(0, 10),
  });
  const [pageLoad, togglePageLoad] = useState(false);

  const [downloadBulkData, setDownBulkData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderType, setOrderType] = useState("all");

  const dataLoad = async () => {
    setLoading(true);
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/sales/downloadBulkOrderData", {
        startDate: date.startDate,
        endDate: date.endDate,
        orderType: orderType,
      })
      .then((res) => {
        if (res.data.success) {
          setDownBulkData(res.data.data || []);
          togglePageLoad(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error of get data", error);
      });
  };

  useEffect(() => {
    dataLoad();
  }, []);

  if (!pageLoad) {
    return (
      <div>
        <h1>Loading</h1>
      </div>
    );
  }

  return (
    <SubCard title={"Download Bulk Order Data"}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid xs={12} sm={12} md={6} lg={3} item>
          <TextField
            id="datetime-local"
            label="Start Date"
            type="date"
            defaultValue={date.startDate}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            style={{
              width: "100%",
            }}
            onChange={(e) =>
              setDate({
                ...date,
                startDate: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextField
            id="datetime-local"
            label="End Date"
            type="date"
            defaultValue={date.endDate}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            style={{
              width: "100%",
            }}
            onChange={(e) =>
              setDate({
                ...date,
                endDate: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormControl fullWidth className={classes.textField} style={{ width: "100%" }}>
            <InputLabel id="order-type-label">Order Type</InputLabel>
            <Select
              labelId="order-type-label"
              id="order-type-select"
              value={orderType}
              label="Order Type"
              onChange={(e) => setOrderType(e.target.value)}
            >
              <MenuItem value="all">All Order</MenuItem>
              <MenuItem value="prepaid">Prepaid Order</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <LoadingButton
            variant="contained"
            style={{
              width: "100%",
            }}
            loadingIndicator="loading..."
            onClick={() => dataLoad()}
            loading={loading}
          >
            Submit
          </LoadingButton>
        </Grid>
        <Grid item lg={3} md={3} sm={12}>
          {!loading && downloadBulkData.length > 0 && (
            <CSVLink
              filename="BulkOrderData.csv"
              headers={bulkChildOrderHeader}
              data={downloadBulkData}
              title="Download data"
              style={{
                textDecoration: "none",
                border: "1px solid #999",
                padding: "10px 20px",
                backgroundColor: "#95c7f1",
              }}
            >
              Download data
            </CSVLink>
          )}
        </Grid>
      </Grid>
    </SubCard>
  );
}

export default BulkDownloadOrderData;
